export const PAYD_URL = process.env.REACT_APP_PAYD_URL || 'http://payd.local';

export const PAYD_API_URL = process.env.REACT_APP_PAYD_API_URL || process.env.REACT_APP_API_URL || 'http://api.payd.local/api/v1';

export const PAYD_GRAPHQL_URL = process.env.REACT_APP_PAYD_GRAPHQL_URL || 'http://api.payd.local/graphql';

export const READONLY_MERCHANT = process.env.REACT_APP_READONLY_MERCHANT === 'true' || false;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development';
export const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE || '';
export const SENTRY_TRACES_SAMPLE_RATE = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE !== undefined
    ? parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE)
    : 0.2;
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE = process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE !== undefined
    ? parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE)
    : 0.1;
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE !== undefined
    ? parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE)
    : 1.0;
